import React from "react";
import helpicon from "../../images/helpicon.svg";
import { Tooltip } from "antd";
import { capitalize } from "utils";

interface SectionIntroProps {
    title: string;
    isRequiredSection: boolean;
    isHelpInfoReq?: boolean;
    isSmall?: boolean;
    tooltipText?: string;
    titleClass?: string;
    description?: string;
}

const SectionTitleAndDescription: React.FC<SectionIntroProps> = ({
    title,
    isRequiredSection,
    isHelpInfoReq,
    tooltipText,
    titleClass,
    description,
    isSmall
}) => {
    return (
        <>
            {/* <label className="text-text-secondary font-semibold capitalize  flex items-center "> */}
            <label className={`text-text-secondary ${titleClass} ${isSmall ? "font-medium" : "font-semibold"} flex items-center ${isSmall ? "text-sm" : "text-base"}`}>
                {title}{isRequiredSection ? <span className="text-primary">*</span> : ""}
                {isHelpInfoReq ? (
                    <Tooltip title={tooltipText}>
                        <img src={helpicon} alt="Help Icon" className="ps-1 cursor-pointer" />
                    </Tooltip>
                ) : (
                    ""
                )}

            </label>
            {description && <p className={`text-text-quaternary mt-3 ${isSmall ? "text-xs" : "text-sm"} font-normal`}>
                {capitalize(description)}
            </p>
            }
        </>
    );
};

export default SectionTitleAndDescription;